/** Sentences about ingestion rules that more than one page shows. */

export const ONLY_ADMINS_CHANGE_RULES =
  "Only org admins can change ingestion rules.";
